import BaseTourSectionPanel from "@components/tour_sections/BaseTourSectionPanel";

function MaximizeYourExperiencePanel(props) {
  return (
    <BaseTourSectionPanel {...props} panelTitle="Maximize your experience" />
  );
}

export default MaximizeYourExperiencePanel;
